<template>
    <div class="projects-spk2">
        <div class="projects-spk2__wrapper" v-loading="loading">
            <template class="projects-spk2__nomanations">
                <div
                    class="projects-spk2__nomination"
                    v-for="(card, index) in isMobile ? mTabItems : tabItems"
                    :key="index"
                >
                    <div class="projects-spk2__nomination-wrapper" v-if="card._type === 'spk'">
                        <a @click="goToProject({ card: card })" class="projects-spk2__external-link">
                            <div class="projects-spk2__nomination-status">
                                <div
                                    v-if="
                                        card.nominations[0] &&
                                        getDictionaryStageHistoryValue(card.nominations[0].participantStatus)
                                    "
                                >
                                    Статус:
                                    <span :style="statusStyle(card)">
                                        {{ getDictionaryStageHistoryValue(card.nominations[0].participantStatus) }}
                                    </span>
                                </div>
                            </div>
                            <div class="projects-spk2__nomination-img">
                                <img
                                    :src="card.image_link || require('../../../assets/images/no-pic.svg')"
                                    :alt="card.name"
                                />
                            </div>

                            <div class="projects-spk2__nomination-title">
                                <span>{{ card.name }}</span>
                            </div>
                        </a>
                        <div v-if="card.status === 'active'" class="projects-spk2__nomination-actions-active">
                            <div
                                @click="goToProject({ card: card })"
                                class="projects-spk2__nomination-actions-active-router"
                            >
                                <img
                                    src="~@/assets/images/projects-play-btn.svg"
                                    class="projects-spk2__nomination-actions-active-img"
                                />
                                <span class="projects-spk2__nomination-actions-active-txt"> Продолжить участие </span>
                            </div>
                            <a
                                v-if="card.project_site_link"
                                @click="
                                    goToSite({
                                        link: card.project_site_link,
                                    })
                                "
                                class="projects-spk2__nomination-actions-active-link"
                            >
                                на сайт проекта
                            </a>
                        </div>
                        <div v-else class="projects-spk2__nomination-actions-finished">
                            <div class="projects-spk2__nomination-actions-finished-router">
                                <img
                                    src="~@/assets/images/porject-finish-icon.svg"
                                    class="projects-spk2__nomination-actions-finished-img"
                                />
                                <span class="projects-spk2__nomination-actions-finished-txt"> Проект завершен </span>
                            </div>
                            <a
                                v-if="card.project_site_link"
                                @click="
                                    goToSite({
                                        link: card.project_site_link,
                                    })
                                "
                                class="projects-spk2__nomination-actions-active-link"
                            >
                                на сайт проекта
                            </a>
                        </div>
                    </div>

                    <div v-else class="involved-projects__nomination-wrapper">
                        <a
                            v-if="card.realization_type == 'external'"
                            @click="goToSite(card.project_site_link)"
                            class="involved-projects__external-link"
                        >
                            <div class="involved-projects__nomination-status">
                                <div
                                    v-if="
                                        card.nominations[0] &&
                                        getDictionaryStageHistoryValue(card.nominations[0].userStatusId)
                                    "
                                >
                                    Статус:
                                    <span :style="statusStyle(card)">
                                        {{ getDictionaryStageHistoryValue(card.nominations[0].userStatusId) }}
                                    </span>
                                </div>
                            </div>
                            <img
                                :src="card.image_link || require('../../../assets/images/no-pic.svg')"
                                :alt="card.name"
                                class="involved-projects__nomination-img"
                            />
                            <div class="involved-projects__nomination-title">
                                <span>{{ card.name }}</span>
                            </div>
                            <div v-if="card.status === 'active'" class="involved-projects__nomination-actions-active">
                                <component
                                    :is="card.status === 'active' ? 'router-link' : 'div'"
                                    :to="{
                                        name: 'SPK',
                                        params: {
                                            projectId: card.project_id,
                                        },
                                    }"
                                >
                                    <div class="involved-projects__nomination-actions-active-router">
                                        <img
                                            src="~@/assets/images/projects-play-btn.svg"
                                            class="involved-projects__nomination-actions-active-img"
                                        />
                                        <span class="involved-projects__nomination-actions-active-txt">
                                            Продолжить участие
                                        </span>
                                    </div>
                                </component>
                                <a
                                    @click="goToSite(card.project_site_link)"
                                    class="involved-projects__nomination-actions-active-link"
                                >
                                    на сайт проекта
                                </a>
                            </div>
                            <div v-else class="involved-projects__nomination-actions-finished">
                                <div class="involved-projects__nomination-actions-finished-router">
                                    <img
                                        src="~@/assets/images/porject-finish-icon.svg"
                                        class="involved-projects__nomination-actions-finished-img"
                                    />
                                    <span class="involved-projects__nomination-actions-finished-txt">
                                        Проект завершен
                                    </span>
                                </div>
                                <a
                                    @click="goToSite(card.project_site_link)"
                                    class="involved-projects__nomination-actions-active-link"
                                >
                                    на сайт проекта
                                </a>
                            </div>
                        </a>

                        <div class="involved-projects__status" v-else>
                            <component
                                :is="card.status === 'active' ? 'router-link' : 'div'"
                                :to="{
                                    name: 'SPK',
                                    params: { projectId: card.project_id },
                                }"
                                class="involved-projects__external-link"
                            >
                                <div class="involved-projects__nomination-status">
                                    <div
                                        v-if="
                                            card.nominations[0] &&
                                            getDictionaryStageHistoryValue(card.nominations[0].userStatusId)
                                        "
                                    >
                                        Статус:
                                        <span :style="statusStyle(card)">
                                            {{ getDictionaryStageHistoryValue(card.nominations[0].userStatusId) }}
                                        </span>
                                    </div>
                                </div>
                                <img
                                    :src="card.image_link || require('../../../assets/images/no-pic.svg')"
                                    :alt="card.name"
                                    class="involved-projects__nomination-img"
                                />
                                <div class="involved-projects__nomination-title">
                                    <span>{{ card.name }}</span>
                                </div>
                            </component>
                            <div v-if="card.status === 'active'" class="involved-projects__nomination-actions-active">
                                <component
                                    :is="card.status === 'active' ? 'router-link' : 'div'"
                                    :to="{
                                        name: 'SPK',
                                        params: { projectId: card.project_id },
                                    }"
                                >
                                    <div class="involved-projects__nomination-actions-active-router">
                                        <img
                                            src="~@/assets/images/projects-play-btn.svg"
                                            class="involved-projects__nomination-actions-active-img"
                                        />
                                        <span class="involved-projects__nomination-actions-active-txt">
                                            Продолжить участие
                                        </span>
                                    </div>
                                </component>
                                <a
                                    v-if="card.project_site_link"
                                    @click="goToSite(card.project_site_link)"
                                    class="involved-projects__nomination-actions-active-link"
                                >
                                    на сайт проекта
                                </a>
                            </div>
                            <div v-else class="involved-projects__nomination-actions-finished">
                                <div class="involved-projects__nomination-actions-finished-router">
                                    <img
                                        src="~@/assets/images/porject-finish-icon.svg"
                                        class="involved-projects__nomination-actions-finished-img"
                                    />
                                    <span class="involved-projects__nomination-actions-finished-txt">
                                        Проект завершен
                                    </span>
                                </div>
                                <a
                                    @click="goToSite(card.project_site_link)"
                                    class="involved-projects__nomination-actions-active-link"
                                >
                                    на сайт проекта
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center">
                    <div
                        v-if="isMobile && tabItems.length > 3 && tabItems.length > mTabItems.length"
                        class="projects-spk2__load-more"
                        @click="loadMoreCards"
                    >
                        Еще {{ tabItems.length - tabsLength }} {{ countedProjectTitle }}
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import declinationOfNumber from '../../../tools/declinationOfNumber';
import strCounter from '@/tools/str_counter';

export default {
    name: 'InvolvedProjectsSPK2',
    props: {
        loading: Boolean,
        itemsSPK2: Array,
        itemsProjects: Array,
        type: String,
        emptyText: String,
        tabIndex: Number,
    },
    data: () => ({
        tabs: [
            {
                label: 'Текущие',
                type: 'active',
            },
            {
                label: 'Завершенные',
                type: 'finished',
            },
        ],
        tabsLength: 3,
        currentTab: 0,
        leftTabsLength: 0,
        itemsLength: 0,
        moreBtnTxt: '',
    }),
    methods: {
        ...mapActions(['loadDictionaryItems']),

        goToSite({ link }) {
            const getLink = (string) => {
                if (string.match('https')) {
                    return string;
                } else {
                    return `https://${string}`;
                }
            };
            window.open(getLink(link), '_blank');
        },
        goToProject({ card }) {
            if (card.alias) {
                return window.open(`https://project.${window.rsvDomain}/${card.alias}`, '_blank');
            }
            window.open(`https://project.${window.rsvDomain}/${card.project_id}`, '_blank');
        },
        tabClicked(index) {
            this.currentTab = index;
        },
        loadMoreCards() {
            this.tabsLength += 3;
        },
        currentTabsLength() {
            const len = this.tabItems.length - this.tabsLength;
            let decTxt = declinationOfNumber(len, 'проект', 'проекта', 'проектов');
            this.moreBtnTxt = `Еще ${len} ${decTxt}`;
        },
        statusStyle(card) {
            if (card.status !== 'active') {
                return { color: '#98A0A9' };
            }
            let statusId = card.nominations[0].userStatusId;
            switch (this.getDictionaryStageHistoryValue(statusId)) {
                case 'Участник':
                    return { color: '#68C87A' };
                case 'Полуфиналист':
                    return { color: '#1AB2D3' };
                case 'Финалист':
                    return { color: '#b18cfe' };
                case 'Победитель':
                    return { color: '#EF5DA8' };
                default:
                    return { color: '#68C87A' };
            }
        },
        getDictionaryStageHistoryValue(val) {
            let stageHistoryItem = this.dictionaryByType('stage_history').filter((x) => x.id == val)[0] || null;
            if (stageHistoryItem && stageHistoryItem.field_value.length > 13) {
                stageHistoryItem.field_value = stageHistoryItem.field_value.slice(0, 13) + '..';
            }
            return stageHistoryItem ? stageHistoryItem.field_value : null;
        },
    },
    watch: {
        tabIndex: {
            handler(val) {
                this.tabClicked(val);
                this.tabsLength = 3;
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(['isMobile', 'dictionaryByType']),
        countedProjectTitle() {
            const len = this.tabItems.length - this.tabsLength;
            return strCounter('проект', '', 'а', 'ов')(len);
        },
        tabType() {
            return this.tabs[this.currentTab].type;
        },
        mTabItems() {
            return this.tabItems.slice(0, this.tabsLength);
        },
        tabItems() {
            return [
                ...this.itemsSPK2
                    .filter((v) => v.status === this.tabType)
                    .map((v) => {
                        v._type = 'spk';
                        return v;
                    }),
                ...this.itemsProjects
                    .filter((v) => v.status === this.tabType)
                    .map((v) => {
                        v._type = 'project';
                        return v;
                    }),
            ];
        },
    },
    async mounted() {
        this.tabsLength = 3;
        await this.loadDictionaryItems('stage_history');
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables';
@import '../../../styles/rem';
@import '../../../styles/mrem';

.projects-spk2 {
    &__wrapper {
        display: flex;
        flex-wrap: wrap;

        @include on-desktop {
            min-width: rem(850);
        }
    }

    &__load-more {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: mrem(206);
        height: mrem(43);
        border: mrem(1) solid #98a0a9;
        border-radius: mrem(4);
        font-style: normal;
        font-weight: 400;
        font-size: mrem(18);
        line-height: mrem(23);
        padding-top: mrem(3);
        color: #98a0a9;

        &::before {
            content: ' ';
            margin-top: mrem(-3);
            margin-right: mrem(8);
            left: mrem(20);
            display: block;
            width: mrem(22);
            height: mrem(16);
            background: url('~@/assets/images/load-more.svg') no-repeat;
            background-size: mrem(23) mrem(16);
        }
    }

    &__nomination {
        background: #f6f9ff;
        min-width: mrem(355);
        border-radius: mrem(10);
        margin-bottom: mrem(20);
        padding: mrem(10);
        box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);

        @include on-desktop {
            min-width: rem(220);
            height: rem(357);
            border-radius: rem(10);
            margin-bottom: rem(18);
            margin-right: rem(23);
            padding: rem(20) rem(12);
            box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);

            &:hover {
                box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.2);
            }

            &:nth-child(3n + 3) {
                margin-right: rem(0);
            }
        }

        &-wrapper {
            display: flex;
            flex-wrap: wrap;

            @include on-desktop {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                flex-direction: column;
                height: 100%;
            }
        }

        &-title {
            font-style: normal;
            font-weight: bold;
            width: mrem(174);
            font-size: mrem(16);
            line-height: mrem(20);
            padding-left: 16px;
            display: flex;
            align-items: center;

            span {
                @include line-clamp(3);
                width: 100%;
            }

            @include on-desktop {
                width: rem(200);
                height: 100%;
                font-size: rem(18);
                line-height: rem(25);
                margin: 0;
                align-items: flex-start;
                padding-left: 0;
            }
        }

        &-status {
            height: mrem(50);
            font-size: mrem(18);
            line-height: mrem(26);

            @include on-desktop {
                height: rem(40);
                font-style: normal;
                font-weight: normal;
                font-size: rem(18);
                line-height: rem(26);
            }
        }

        &-img {
            background: #ffffff;
            width: mrem(125);
            height: mrem(70);
            border-radius: mrem(10);
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;

            @include on-desktop {
                width: rem(198);
                height: rem(111);
                border-radius: rem(10);
                margin-left: rem(0);
                margin-bottom: rem(20);
                padding: 10px 23px;
                flex-shrink: 0;
            }

            img {
                border-radius: 4px;
                object-fit: contain;
                width: 100%;
            }
        }

        &-actions {
            &-active {
                margin-top: 16px;
                width: 100%;
                display: flex;
                flex-direction: row-reverse;

                @include on-desktop {
                    margin-top: auto;
                    flex-direction: column;
                }

                &-router {
                    display: flex;
                    align-items: flex-start;
                    font-size: 16px;
                    font-weight: 350;
                    flex-direction: row-reverse;
                    align-items: center;

                    @include on-desktop {
                        padding-left: 0;
                        margin-bottom: rem(8);
                        cursor: pointer;
                        flex-direction: row;
                    }
                }

                &-img {
                    width: mrem(21);
                    height: mrem(21);
                    margin-left: rem(20);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-left: rem(0);
                        margin-right: rem(10);
                    }
                }

                &-txt {
                    font-size: mrem(18);
                    line-height: mrem(26);

                    @include on-desktop {
                        font-style: normal;
                        font-weight: normal;
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                &-link {
                    font-size: mrem(14);
                    line-height: mrem(26);
                    cursor: pointer;
                    font-style: normal;
                    font-weight: 350;
                    color: #98a0a9;
                    width: 40%;

                    @include on-desktop {
                        font-size: rem(16);
                        line-height: rem(26);
                        margin: auto;
                        text-align: center;
                        width: 100%;
                    }
                }
            }

            &-finished {
                display: flex;
                flex-direction: column;
                align-items: center;

                &-router {
                    margin-top: rem(10);
                    width: 100%;
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;
                    justify-content: center;
                    @include on-desktop {
                        flex-direction: row;
                        padding-left: rem(10);
                        margin-bottom: rem(8);
                    }
                }

                &-img {
                    width: mrem(20);
                    height: mrem(20);
                    margin-left: mrem(5);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-left: rem(0);
                        margin-right: rem(5);
                    }
                }

                &-txt {
                    font-size: mrem(18);
                    line-height: mrem(26);
                    color: #98a0a9;

                    @include on-desktop {
                        font-style: normal;
                        font-weight: normal;
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                a {
                    width: 100%;
                }
            }
        }
    }

    &__external-link {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;

        @include on-desktop {
            flex-wrap: nowrap;
            flex-direction: column;
            cursor: pointer;
        }
    }

    &__nomination-status {
        width: 100%;
        height: auto;
        padding-bottom: 5px;

        @include on-desktop {
            width: auto;
            display: flex;
            height: 30px;
            flex-direction: column;
        }
    }
}

.involved-projects {
    &-wrapper {
        display: flex;
        flex-wrap: wrap;

        @include on-desktop {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
    }

    &__load-more {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: mrem(206);
        height: mrem(43);
        border: mrem(1) solid #98a0a9;
        border-radius: mrem(4);
        font-style: normal;
        font-weight: 400;
        font-size: mrem(18);
        line-height: mrem(23);
        padding-top: mrem(3);
        color: #98a0a9;

        &::before {
            content: ' ';
            margin-top: mrem(-3);
            margin-right: mrem(8);
            left: mrem(20);
            display: block;
            width: mrem(22);
            height: mrem(16);
            background: url('~@/assets/images/load-more.svg') no-repeat;
            background-size: mrem(23) mrem(16);
        }
    }

    &__nomination {
        background: #f6f9ff;
        min-width: mrem(355);
        border-radius: mrem(10);
        margin-bottom: mrem(20);
        padding: mrem(10);
        box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);

        @include on-desktop {
            min-width: rem(220);
            height: rem(357);
            border-radius: rem(10);
            margin-bottom: rem(18);
            margin-right: rem(23);
            padding: rem(20) rem(12);
            box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);

            &:hover {
                box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.2);
            }

            &:nth-child(3n + 3) {
                margin-right: rem(0);
            }
        }

        &-wrapper {
            @include on-desktop {
                display: flex;
                align-items: center;
                flex-direction: column;
                height: 100%;
            }
        }

        &-title {
            font-style: normal;
            font-weight: bold;
            font-size: mrem(16);
            overflow: hidden;
            line-height: mrem(20);
            display: flex;
            align-items: center;
            padding-left: 16px;
            margin: auto 0;
            width: mrem(200);
            white-space: normal;

            @include on-desktop {
                width: rem(200);
                font-size: rem(18);
                line-height: rem(25);
                margin: 0;
                align-items: flex-start;
                padding-left: 0;
            }
        }

        &-status {
            height: mrem(50);
            font-size: mrem(18);
            line-height: mrem(26);
            width: 100%;

            @include on-desktop {
                height: rem(40);
                font-style: normal;
                font-weight: normal;
                font-size: rem(18);
                line-height: rem(26);
            }
        }

        &-img {
            background: #ffffff;
            width: mrem(125);
            height: mrem(70);
            border-radius: mrem(10);
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
            object-fit: cover;

            @include on-desktop {
                width: rem(198);
                height: rem(111);
                border-radius: rem(10);
                margin-left: rem(0);
                margin-bottom: rem(20);
                padding: 10px 23px;
                flex-shrink: 0;
            }

            img {
                border-radius: 4px;
                object-fit: contain;
            }
        }

        &-actions {
            &-active {
                margin-top: 16px;
                width: 100%;
                display: flex;
                flex-direction: row-reverse;

                @include on-desktop {
                    margin-top: auto;
                    flex-direction: column;
                }

                &-router {
                    display: flex;
                    align-items: flex-start;
                    font-size: 16px;
                    font-weight: 350;
                    flex-direction: row-reverse;
                    align-items: center;

                    @include on-desktop {
                        padding-left: 0;
                        margin-bottom: rem(8);
                        cursor: pointer;
                        flex-direction: row;
                    }
                }

                &-img {
                    width: mrem(21);
                    height: mrem(21);
                    margin-left: rem(20);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-left: rem(0);
                        margin-right: rem(10);
                    }
                }

                &-txt {
                    font-size: mrem(18);
                    line-height: mrem(26);

                    @include on-desktop {
                        font-style: normal;
                        font-weight: normal;
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                &-link {
                    font-size: mrem(14);
                    line-height: mrem(26);
                    cursor: pointer;
                    font-style: normal;
                    font-weight: 350;
                    color: #98a0a9;
                    width: 40%;

                    @include on-desktop {
                        font-size: rem(16);
                        line-height: rem(26);
                        width: 100%;
                        text-align: center;
                    }
                }
            }

            &-finished {
                display: flex;
                flex-direction: column;
                align-items: center;

                &-router {
                    margin-top: 16px;
                    width: 100%;
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;
                    justify-content: center;
                    @include on-desktop {
                        flex-direction: row;
                        padding-left: rem(10);
                        margin-bottom: rem(8);
                    }
                }

                &-img {
                    width: mrem(20);
                    height: mrem(20);
                    margin-left: mrem(5);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-left: rem(0);
                        margin-right: rem(5);
                    }
                }

                &-txt {
                    font-size: mrem(18);
                    line-height: mrem(26);
                    color: #98a0a9;

                    @include on-desktop {
                        font-style: normal;
                        font-weight: normal;
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                a {
                    width: 100%;
                }
            }
        }
    }

    &__external-link {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;

        @include on-desktop {
            flex-direction: column;
            cursor: pointer;
        }
    }

    &__status {
        @include on-desktop {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    }
}

.center {
    display: flex;
    margin: 0 auto;
}
</style>
